/**
 * OSS文件管理状态管理
 * 定义了OSS文件管理页面的表格列信息、查询参数、表格数据等状态
 * @author PeterLee
 * @date 2022-07-15
 */
const state = {
    /**
     * 表单校验规则
     */
    rules: {
        // 文件路径输入框的校验规则
        objectKey: [{
            required: false,  // 非必填项
            message: '请输入文件路径',  // 校验失败提示信息
            trigger: 'blur'  // 失去焦点时触发校验
        }],
        // 文件前缀输入框的校验规则
        prefix: [{
            required: false,  // 非必填项
            message: '请输入文件前缀',  // 校验失败提示信息
            trigger: 'blur'  // 失去焦点时触发校验
        }]
    },
    
    /**
     * 表格列配置信息
     * 定义了表格中每一列的显示状态和标题
     */
    columnInfo: {
        /**
         * 文件路径列
         * objectKey: OSS文件的完整路径
         */
        objectKey: {
            visible: true,  // 是否显示该列
            label: "文件路径"  // 列标题
        },
        /**
         * 文件大小列
         * size: 文件大小，单位为字节
         */
        size: {
            visible: true,  // 是否显示该列
            label: "文件大小"  // 列标题
        },
        /**
         * 存储类型列
         * storageClass: OSS的存储类型，如标准存储、低频访问存储等
         */
        storageClass: {
            visible: true,  // 是否显示该列
            label: "存储类型"  // 列标题
        },
        /**
         * 最后修改时间列
         * lastModified: 文件或目录的最后修改时间
         */
        lastModified: {
            visible: true,  // 是否显示该列
            label: "最后修改时间"  // 列标题
        },
        /**
         * ETag列
         * etag: 文件的唯一标识符，用于验证文件完整性
         */
        etag: {
            visible: false,  // 是否显示该列
            label: "ETag"  // 列标题
        }
    },
    
    /**
     * 表格数据（查询结果）
     * 存储从API获取的文件和目录列表
     */
    tableData: [],
    
    /**
     * 共有数据条数（分页控件）
     * 用于分页显示的总记录数
     */
    totalCount: 0,
    
    /**
     * 查询参数
     * 用于向API发送文件列表查询请求
     */
    queryParams: {
        currPage: 1,  // 当前页数（分页控件）
        limit: 10,  // 每页条数（分页控件）
        ascOrder: false,  // 是否升序 - 排序方向
        orderField: "lastModified",  // 排序字段 - 默认按最后修改时间排序
        
        /**
         * 查询参数详情
         */
        param: {
            objectKey: undefined,  // 文件路径 - 用于精确匹配文件路径
            prefix: undefined,  // 文件前缀 - 用于模糊匹配以指定前缀开头的文件或目录
            delimiter: '/'  // 分隔符 - 用于列出目录结构，通常使用'/'作为路径分隔符
        }
    },
    
    /**
     * 展示搜索区
     * 控制搜索区域的显示/隐藏
     */
    showSearch: false,
    
    /**
     * 批量操作选中list
     * 存储表格中选中的行数据，用于批量操作
     */
    selectList: [],
    
    /**
     * 当前路径
     * 当前浏览的OSS文件系统路径
     */
    currentPath: '/',
    
    /**
     * 当前路径列表
     * 用于面包屑导航，存储路径的各个层级
     */
    currentPathList: [],
    
    /**
     * 上传对话框
     * 控制上传文件对话框的显示/隐藏
     */
    uploadDialogVisible: false,
    
    /**
     * 上传表单
     * 用于存储上传文件的表单数据
     */
    uploadForm: {
        objectKey: ''  // 上传文件的目标路径
    },
    
    /**
     * 文件列表
     * 用于存储待上传的文件列表
     */
    fileList: []
}

export default state